enum OpeningHoursType {
    UNSET = 'UNSET',
    O247 = 'O247',
    CUSTOM = 'CUSTOM'
}

export default OpeningHoursType;
